export enum GroupMeetingPatientSubtype {
    interimMdo = 'interimMdo',
    regularMdo = 'regularMdo',
}
